import { useRef } from "react";
import { Printer } from "react-feather";
import { useReactToPrint } from "react-to-print";
import { Card, CardBody, CardHeader } from "reactstrap";
import { H3 } from "../../../../../AbstractElements";
import { CreatedByMe, Href } from "../../../../../Utils/Constants";
import CreatedByMeTable from "./CreatedByMeTable";

export default function TaskList() {
  const contentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({ contentRef });
  return (
    <Card className="mb-0">
      <CardHeader className="d-flex card-no-border pb-0">
        <H3 className="mb-0">{CreatedByMe}</H3>
        <a href={Href} onClick={() => handlePrint()}>
          <Printer className="me-2" /> {"Print"}
        </a>
      </CardHeader>
      <CardBody className="p-0">
        <CreatedByMeTable contentRef={contentRef} />
      </CardBody>
    </Card>
  );
}
